'use client'

import { create } from 'zustand'

export type PaymentMethodKey =
  | 'checkout'
  | 'summer-pass'
  | 'default'
  | 'review-pending'
  | 'manage-premium'
  | 'purchase-premium'
  | 'add-lifeguard'
  | 'manage-membership'
  | 'check-in'
  | 'listing-pool-pass-purchase'

const DEFAULT_MAP: Record<PaymentMethodKey, boolean> = {
  checkout: false,
  'summer-pass': false,
  default: false,
  'review-pending': false,
  'manage-premium': false,
  'purchase-premium': false,
  'add-lifeguard': false,
  'manage-membership': false,
  'check-in': false,
  'listing-pool-pass-purchase': false,
}

interface IPaymentMethodsStore {
  isPaymentOpen: Record<PaymentMethodKey, boolean>
  isAddPaymentOpen: Record<PaymentMethodKey, boolean>
  setIsPaymentOpen: (key: PaymentMethodKey, isPaymentOpen: boolean) => void
  setIsAddPaymentOpen: (
    key: PaymentMethodKey,
    isAddPaymentOpen: boolean
  ) => void
  getIsPaymentOpen: (key: PaymentMethodKey) => boolean
  getIsAddPaymentOpen: (key: PaymentMethodKey) => boolean
}

export const usePaymentMethodsStore = create<IPaymentMethodsStore>(
  (set, get) => ({
    isPaymentOpen: { ...DEFAULT_MAP },
    isAddPaymentOpen: { ...DEFAULT_MAP },

    // setters
    setIsPaymentOpen: (key, isPaymentOpen) =>
      set({ isPaymentOpen: { ...get().isPaymentOpen, [key]: isPaymentOpen } }),
    setIsAddPaymentOpen: (key, isAddPaymentOpen) =>
      set({
        isAddPaymentOpen: {
          ...get().isAddPaymentOpen,
          [key]: isAddPaymentOpen,
        },
      }),

    // getters
    getIsPaymentOpen: (key) => get().isPaymentOpen[key],
    getIsAddPaymentOpen: (key) => get().isAddPaymentOpen[key],
  })
)
